/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Platform_ExtensionInputs */

const en_pricing_platform_extension = /** @type {(inputs: Pricing_Platform_ExtensionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Browser extension`)
};

const es_pricing_platform_extension = /** @type {(inputs: Pricing_Platform_ExtensionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extensión del navegador`)
};

/**
* | output |
* | --- |
* | "Browser extension" |
*
* @param {Pricing_Platform_ExtensionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const pricing_platform_extension = /** @type {((inputs?: Pricing_Platform_ExtensionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Platform_ExtensionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_pricing_platform_extension(inputs)
	return en_pricing_platform_extension(inputs)
});